import React, { useState, useEffect } from "react";
import { omLogo } from "../../assets/images/";
import { useHistory } from "react-router-dom";
import { Typography, InputAdornment, MenuItem } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../js/reducers/snackbar";
import { setAlertDialog } from "../../js/reducers/alertDialog";
import { OAuth as OAuthActions } from "../../js/actions";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import HelpOutlineOutlinedIcon from "@material-ui/icons/HelpOutlineOutlined";

const useStyles = makeStyles((theme) => ({
  parentDiv: {
    width: "100vw",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "1.5rem",
    boxSizing: "border-box",
  },
  loginCard: {
    position: "relative",
    width: "100%",
    maxWidth: "420px",
    padding: "2rem",
    borderRadius: "24px",
    background: "rgba(255, 255, 255, 0.72)",
    backdropFilter: "blur(22px)",
    WebkitBackdropFilter: "blur(22px)",
    border: "1px solid rgba(255, 255, 255, 0.6)",
    boxShadow:
      "0 20px 60px rgba(3, 46, 79, 0.28), inset 0 1px 0 rgba(255,255,255,0.6)",
    animation: "$cardFadeIn 0.6s ease",
    [theme.breakpoints.down("xs")]: {
      padding: "2rem 1.5rem",
      borderRadius: "20px",
    },
  },
  "@keyframes cardFadeIn": {
    from: { opacity: 0, transform: "translateY(24px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  logoWrap: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "2rem",
  },
  logo: {
    height: "64px",
    width: "auto",
    objectFit: "contain",
  },
  title: {
    color: "#005691",
    fontWeight: 700,
    marginBottom: "0.5rem",
  },
  subtitle: {
    color: "#5a6b78",
    marginBottom: "1.5rem",
    fontSize: "0.9rem !important",
  },
  field: {
    marginBottom: "1.25rem",
    "& .MuiInputBase-root": {
      margin: "0 !important",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "14px !important",
      background: "rgba(255,255,255,0.65)",
      transition: "box-shadow 0.25s ease, background 0.25s ease",
      "& fieldset": {
        borderColor: "rgba(11, 60, 93, 0.15)",
      },
      "&:hover fieldset": {
        borderColor: "rgba(3, 169, 243, 0.5)",
      },
      "&.Mui-focused": {
        background: "rgba(255,255,255,0.95)",
        boxShadow: "0 6px 18px rgba(3, 169, 243, 0.18)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#03A9F3",
        borderWidth: "1.5px",
      },
    },
    "& .MuiOutlinedInput-input": {
      padding: "16.5px 2px",
      fontSize: "0.90em !important",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "#0288d1",
    },
  },
  selectField: {
    marginBottom: "1.25rem",
    "& .MuiInputBase-root": {
      margin: "0 !important",
      borderRadius: "14px !important",
      background: "rgba(255,255,255,0.65)",
      transition: "box-shadow 0.25s ease, background 0.25s ease",
      "&.Mui-focused": {
        background: "#ffffff !important",
        boxShadow: "0 6px 18px rgba(3, 169, 243, 0.18)",
      },
    },
    "& .MuiOutlinedInput-root": {
      padding: "4px 14px !important",
      "& fieldset": {
        borderColor: "rgba(11, 60, 93, 0.15)",
      },
      "&:hover fieldset": {
        borderColor: "rgba(3, 169, 243, 0.5)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#03A9F3",
        borderWidth: "1.5px",
      },
    },
    "& .MuiAutocomplete-input": {
      padding: "16.5px 14px 16.5px 2px !important",
      fontSize: "0.90em !important",
      background: "transparent !important",
      "&:focus": {
        background: "transparent !important",
      },
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "#0288d1",
    },
  },
  autocompletePaper: {
    borderRadius: "12px",
    marginTop: "5px",
    background: "#ffffff",
    boxShadow: "0 8px 30px rgba(3, 46, 79, 0.18)",
    border: "1px solid rgba(11, 60, 93, 0.08)",
    "& .MuiList-root": {
      padding: "6px",
      background: "#ffffff",
    },
    "& .MuiListItem-gutters": {
      paddingLeft: "5px",
      paddingRight: "5px",
    },
    "& .MuiListItem-root.Mui-focusVisible": {
      backgroundColor: "transparent",
    },
  },
  inputIcon: {
    color: "#7a8b96",
  },
  menuItem: {
    fontSize: "0.90rem",
    lineHeight: 1.4,
    minHeight: "auto",
    paddingTop: "0px",
    paddingBottom: "0px",
    "&.Mui-selected": {
      backgroundColor: "rgba(3, 169, 243, 0.12)",
      "&:hover": {
        backgroundColor: "rgba(3, 169, 243, 0.16)",
      },
    },
  },
  submitButton: {
    padding: "0.6rem",
    borderRadius: "14px",
    fontWeight: 700,
    fontSize: "0.95rem !important",
    letterSpacing: "0.03em",
    textTransform: "none",
    color: "#fff",
    background: "linear-gradient(135deg, #0288d1 0%, #0B4759 100%)",
    display: "flex",
    justifyContent: "center",
    margin: "0.5rem auto",
    width: "30%",
    "&:hover": {
      background: "linear-gradient(135deg, #03A9F3 0%, #0B4759 100%)",
    },
  },
  backLink: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    color: "#0288d1",
    fontSize: "0.85rem !important",
    fontWeight: 600,
    marginTop: "1.4rem",
    transition: "color 0.2s ease",
    "&:hover": {
      color: "#0B4759",
      textDecoration: "underline",
    },
  },
  backIcon: {
    fontSize: "1.1rem !important",
    marginRight: "0.3rem",
  },
}));

const PasskeySet = ({ registrationId }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const [secretAnswer, setSecretAnswer] = useState("");
  const [secretAnswerHelper, setSecretAnswerHelper] = useState("");
  const [questions, setQuestions] = useState([]);
  const [secretQuestion, setSecretQuestion] = useState("");
  const [secretQuestionHelper, setSecretQuestionHelper] = useState("");

  useEffect(() => {
    dispatch(OAuthActions.getAllSecretQuestions()).then(function (response) {
      setQuestions(response.secretQuestions);
    });
  }, []);

  const handleChange = (event) => {
    setSecretAnswer(event.target.value);
    setSecretAnswerHelper("");
  };

  const handleQuestionChange = (event, newValue) => {
    setSecretQuestionHelper("");
    if (newValue) {
      setSecretQuestion(newValue.uid);
    } else {
      setSecretQuestion("");
    }
  };

  const submit = () => {
    if (!secretQuestion || secretAnswer.trim() === "") {
      if (!secretQuestion) {
        setSecretQuestionHelper("Please select a secret question");
      }
      if (secretAnswer.trim() === "") {
        setSecretAnswerHelper("Please enter an answer for the selected question");
      }
      return;
    }

    dispatch(
      OAuthActions.patchSecretanswer(
        registrationId,
        secretQuestion,
        secretAnswer
      )
    ).then(function (success) {
      if (success["error"] === undefined) {
        history.push("/register/" + registrationId);
        dispatch(
          setSnackbar(
            true,
            "success",
            "Step 1: Successful. kindly continue with creating/resetting your new password"
          )
        );
      } else {
        if (success.error == "E0033") {
          history.goBack();
        }
        dispatch(
          setAlertDialog(
            true,
            null,
            "error",
            "Passkey Settings",
            "New passkey set is unsuccessful.\nDetails Of Failure: " +
            success.message,
            "OK",
            ""
          )
        );
      }
    });
  };

  return (
    <div className={classes.parentDiv}>
      <div className={classes.loginCard}>
        <div className={classes.logoWrap}>
          <img src={omLogo} alt="login_logo" className={classes.logo} />
        </div>

        <Typography variant="h4" align="center" className={classes.title}>
          Forgot Password
        </Typography>
        <Typography variant="body1" align="center" className={classes.subtitle}>
          Please select a secret question and provide the appropriate answer.
        </Typography>

        <Autocomplete
          fullWidth
          disableClearable
          options={questions}
          getOptionLabel={(option) => option.question || ""}
          getOptionSelected={(option, value) => option.uid === value.uid}
          value={questions.find((q) => q.uid === secretQuestion) || null}
          onChange={handleQuestionChange}
          renderInput={(params) => (
            <TextField
              {...params}
              required
              variant="outlined"
              className={classes.selectField}
              id="secret-question"
              placeholder="Secret question"
              error={secretQuestionHelper.length !== 0}
              helperText={secretQuestionHelper}
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position="start">
                    <HelpOutlineOutlinedIcon className={classes.inputIcon} />
                  </InputAdornment>
                ),
              }}
            />
          )}
          PaperComponent={({ children }) => (
            <div className={classes.autocompletePaper}>{children}</div>
          )}
          renderOption={(option) => (
            <MenuItem
              className={classes.menuItem}
              key={option.uid}
              value={option.uid}
              style={{
                whiteSpace: "normal",
                wordBreak: "break-word",
                display: "block",
              }}
            >
              {option.question}
            </MenuItem>
          )}
        />

        <TextField
          fullWidth
          required
          variant="outlined"
          className={classes.field}
          error={secretAnswerHelper.length !== 0}
          helperText={secretAnswerHelper}
          onChange={(event) => handleChange(event, "answer")}
          id="secret-answer"
          placeholder="Answer"
          value={secretAnswer}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LockOutlinedIcon className={classes.inputIcon} />
              </InputAdornment>
            ),
          }}
        />

        <Button
          size="large"
          variant="contained"
          className={classes.submitButton}
          onClick={submit}
        >
          Next
        </Button>

        <Typography
          className={classes.backLink}
          onClick={() => history.goBack()}
        >
          <ArrowBackIcon className={classes.backIcon} />
          Back
        </Typography>
      </div>
    </div>
  );
};

export default React.memo(PasskeySet);
